/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable max-len */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable complexity */
import './styles.css';

import React, { useRef, useState, useMemo } from 'react';
import { Tooltip as DSTooltip, Link, Button, useTooltip, Typography } from '@vtblife/uikit';
import { errorCatcherWrap } from '@search/error/src/catcher';
import { Currency } from '@search/filter-enums/enums/Currency';
import { SearchRoute, useRouter } from '@search/offer-search-routes/src';
import badgeLabel from '@search/vtbeco-frontend-core/dict/offer-badge';
import {
    ClassifiedAnalytics
} from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedAnalytics';
import { ModeratorExtension } from '@search/vtbeco-frontend-core/domain/offer/ModeratorExtension';
import { useOfferPhoneQuery } from '@search/vtbeco-frontend-core/domain/offer/search/page/OfferPhoneQuery';
import {
    areaCompat,
    areaUnitCompat
} from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery/helpers/areaCompat';
import {
    dealTypeFilterCompat, dealTypePeriodCompat,
    OfferSnippetModel, realtyObjectFilterCompat,
    useOfferCompat,
    useOfferVisited,
    useOfferCardLink
} from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery';
import { AgentFavoritesDropdown } from '@search/classified-common/src/Agent/AgentFavoritesDropdown/AgentFavoritesDropdown';

import Price from '@search/vtbeco-frontend-core/view/common/components/Price';
import PriceDetail from '@search/vtbeco-frontend-core/view/common/components/PriceDetail';
import { LinkSnippet } from '@search/vtbeco-frontend-core/view/common/components/Snippet/LinkSnippet';
import { Badge } from '@search/vtbeco-frontend-core/view/common/components/Badge';
import { DefaultBadge } from '@search/vtbeco-frontend-core/view/common/components/Badge/DefaultBadge';
import { BadgeBox } from '@search/vtbeco-frontend-core/view/common/components/BadgeBox';
import { OfferRouteSnippet } from '@search/vtbeco-frontend-core/view/common/components/OfferRouteSnippet';
import { SellerSnippet } from '@search/vtbeco-frontend-core/view/common/components/Seller/SellerSnippet/SellerSnippet';
import { VTBCoreYMapDesktop } from '@search/vtbeco-frontend-core/view/common/components/YMap/Desktop';
import {
    useOfferViewAnalytics
} from '@search/vtbeco-frontend-core/view/common/hooks/useOfferViewAnalytics';
import GallerySnippet from '@search/vtbeco-frontend-core/view/desktop/components/snippet/parts/GallerySnippet';
import Tooltip from '@search/vtbeco-ui/src/components/controls/Tooltip';
import { useOnClickOutside } from '@search/hooks/src/useOnClickOutside';
import classname from '@search/classname/src';
import { useFavoritesButtonState, useHiddenButtonState } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/useFavoritesButtonState';
import { FavoritesButton } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/FavoritesButton';
import { NotesButton } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/NotesButton';
import { HideButton } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/HideButton';
import { useClickerTracker } from '@search/vtbeco-frontend-core/src/services/clickerTracker/useClickerTracker';
import { OfferPhoneModal2 } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/OfferPhoneModal2';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { getOfferSimilarGtmIds } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery';

import { useOfferPhoneModalOpener } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/useOfferPhoneModal';
import { ClClickableAddress } from '@search/classified-common/src/ClClickableAddress/ClClickableAddress';
import ReportButton from '@search/vtbeco-frontend-core/view/common/components/ReportButton';
import { Phone } from '@search/vtbeco-frontend-core/view/common/components/Phone';
import { useSubscribeToPriceModalState } from '@search/vtbeco-frontend-core/view/common/components/SubscribeToPriceChange/useSubscribeToPriceModalState';
import { useSubscribeToPriceChange } from '@search/vtbeco-frontend-core/view/common/components/SubscribeToPriceChange/useSubscribeToPriceChange';
import { SubscribeToPriceChange } from '@search/vtbeco-frontend-core/view/common/components/SubscribeToPriceChange';
import { SubscribeToPriceModal } from '@search/vtbeco-frontend-core/view/common/components/SubscribeToPriceChange/SubscribeToPriceModal';
import { TooltipProps } from '@vtblife/uikit/dist/components/tooltip/types';
import { NotesEditor } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/NotesEditor';
import { CALLTOUCH_ID } from '@search/classified-common/src/scripts/useCalltouch';
// import { CallToActionButton2 } from '@search/vtbeco-frontend-core/view/common/components/CallToActionButton/CallToActionButton2';
import { useM2AuthContext } from '@search/auth/src/M2AuthProvider';

import { LayoutSnippet } from '../parts/LayoutSnippet';

const cn = classname.bind(null, 'OfferSnippet');

interface IHoverTooltipProps extends Omit<TooltipProps, 'to'> {
    visible: boolean;
    text: string;
}

const HoverTooltip: React.FC<IHoverTooltipProps> = ({
    text,
    visible,
    children,
    ...props
}) => {
    const { to, registerControl } = useTooltip();

    return (
        <div ref={el => el ? registerControl(el) : undefined}>
            {children}
            {visible ? (
                <DSTooltip
                    {...props}
                    to={to}
                >
                    <div style={{ maxWidth: '210px' }}>{text}</div>
                </DSTooltip>
            ) : null}
        </div>
    );
};

// maybe remove?
export const OfferSnippet = React.memo(errorCatcherWrap(function OfferSnippet(
    {
        disableIdle,
        model,
        isCreatedAtVisible,
        index,
        gtmlClickNewBuildingLink = 'cl_ToNB_Snippet_ZK_pointer_link',
        offerSimilarGtmIds,
        borderEnabled,
        userId
    }: {
        borderEnabled?: boolean;
        disableIdle?(): void;
        model: OfferSnippetModel;
        index: number;
        userId?: string;
        isCreatedAtVisible?: boolean;
        gtmlClickNewBuildingLink?: string;
        offerSimilarGtmIds?: ReturnType<typeof getOfferSimilarGtmIds>;
    }
) {
    const { auth } = useM2AuthContext();
    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const router = useRouter();
    const searchRoute = router.route(SearchRoute);
    const [ , setMapVisible ] = useState(false);
    const wrapperRef = useRef<HTMLDivElement | undefined>(undefined);
    const offerRef = useRef<HTMLDivElement>(null);
    const { trackPhoneView } = useClickerTracker();
    const isMyOffer = userId && userId === model.seller.placementUserId;

    const handleCloseMap = React.useCallback(() => setMapVisible(false), [ setMapVisible ]);

    useOnClickOutside([ wrapperRef ], handleCloseMap);

    const [ isHover, setIsHover ] = useState(false);
    const hoverSnippet = () => setIsHover(true);
    const blurSnippet = () => setIsHover(false);

    const {
        addresses,
        realtyObject,
        dealType,
        seller,
        isNewBuilding,
        isNewBuildingDeveloperFlat,
        hasAnyPriority,
        isPledge,
        description,
        regionId,
        price,
        coordinates,
        pictures,
        offerPhoneClickGtmId,
        offerSnippetClickGtmId,
        offerRoutes,
        metersToCenter,
        locatedInCenter,
        isPit,
        onlineView
    } = useOfferCompat(model);

    const { isVisited, enableIsVisited } = useOfferVisited(model);

    const { offerUrl } = useOfferCardLink(model);
    const isSaleOffer = dealType?.__typename === 'ProfOfferDealSell';
    const isSellFlat = realtyObject?.__typename === 'ProfOfferFlat' && isSaleOffer;

    let metersToCenterText = '';

    if (metersToCenter) metersToCenterText = `до центра ${metersToCenter} км`;
    if (locatedInCenter) metersToCenterText = 'В центре';

    const favorites = useFavoritesButtonState({
        id: model.id,
        noteTextInitial: model.noteText,
        isFavorite: model.isFavorite ?? false,
        eventAddId: isSaleOffer && realtyObject?.__typename === 'ProfOfferFlat' ?
            ClassifiedAnalytics.SearchCardSaleFlatAddFavorites :
            undefined,
        organizationName: model.seller.organizationName
    });

    const hidden = useHiddenButtonState({
        id: model.id,
        isHidden: model.isHidden ?? false
    });

    const phone = useOfferPhoneQuery({
        callTouchId: model.realtyObject?.__typename === 'ProfOfferFlat' && model.realtyObject.building?.isNewbuilding ?
            CALLTOUCH_ID :
            undefined
    });

    const {
        closePhoneModal,
        openPhoneModal,
        isPhoneModalOpened
    } = useOfferPhoneModalOpener({ offerId: model.id });
    const [ placeCallPhoneModal, setPlaceCallPhoneModal ] = useState<'check_request_link' | 'check_request_clop'>();

    const isPhone = false;

    let analyticsInfo = {
        event: '',
        offerId: model.id,
        organizationName: seller.organizationName
    };

    if (isNewBuildingDeveloperFlat) {
        analyticsInfo = {
            ...analyticsInfo,
            'nb-id': realtyObject?.__typename === 'ProfOfferFlat' && realtyObject?.building?.newBuildingId,
            'nb-name': realtyObject?.__typename === 'ProfOfferFlat' && realtyObject?.building?.newBuildingBasicInfo?.title,
            'developer-name': seller.organizationName ?? ''
        };
    }

    const handlePhoneLoad = React.useCallback(async (
        event?: React.MouseEvent<Element, MouseEvent>,
        placeCall: 'check_request_link' | 'check_request_clop' = 'check_request_clop'
    ) => {
        dataLayerPush({ event: 'up_evt_phone', partner: model.fromCian ? 'cian' : 'unknown' });
        offerPhoneClickGtmId && dataLayerPush({ ...analyticsInfo, event: offerPhoneClickGtmId });
        if (offerSimilarGtmIds?.phoneShown) {
            dataLayerPush({ ...analyticsInfo, event: offerSimilarGtmIds?.phoneShown });
        }
        if (isPit) dataLayerPush({ event: 'classified_im_trade_serp_show_tel' });

        ! isNewBuilding && isSellFlat && dataLayerPush({ event: 'up_action', theme: 'legal', type: 'check_click' });
        setPlaceCallPhoneModal(placeCall);

        if (phone.phoneHref) {
            openPhoneModal();
            trackPhoneView(model.id, phone.countryCode, phone.number);
            disableIdle?.();
            return;
        }

        await phone.load({ offerId: model.id });

        openPhoneModal();
        // trackPhoneView(model.id);
        disableIdle?.();
    }, [
        dataLayerPush,
        openPhoneModal,
        disableIdle,
        trackPhoneView,
        offerPhoneClickGtmId,
        analyticsInfo,
        phone,
        model,
        isPit,
        offerSimilarGtmIds,
        isNewBuilding,
        isSellFlat
    ]);

    const handleOfferSnippetClick = React.useCallback(() => {
        offerSnippetClickGtmId && dataLayerPush({ ...analyticsInfo, event: offerSnippetClickGtmId });
        dataLayerPush({ event: 'up_offer_click', partner: model.fromCian ? 'cian' : 'unknown' });
        if (offerSimilarGtmIds?.click) {
            dataLayerPush({ ...analyticsInfo, event: offerSimilarGtmIds?.click });
        }

        enableIsVisited();

        if (isPit) dataLayerPush({ event: 'classified_im_trade_open_offer' });
        // if (offerUrl) window.open(offerUrl, '_blank');
    }, [
        enableIsVisited,
        offerUrl,
        dataLayerPush,
        offerSnippetClickGtmId,
        analyticsInfo,
        offerSimilarGtmIds,
        isPit
    ]);

    useOfferViewAnalytics({
        hasHighlightPriority: model.status?.hasHighlight,
        hasTop: model.status?.hasTop,
        isNewBuilding,
        offerRef,
        offerId: model.id,
        isSaleOffer,
        organizationName: seller.organizationName
    });

    const getStationUrl = React.useCallback(
        (stationId: number) => searchRoute.url({
            dealType: dealTypeFilterCompat(dealType),
            categoryType: realtyObjectFilterCompat(realtyObject),
            region: regionId,
            metroIds: [ stationId ]
        }),
        [ searchRoute, dealType, realtyObject, regionId ]
    );

    const {
        isOpenSubscribeToPriceModal,
        openSubscribeToPriceModal,
        closeSubscribeToPriceModal
    } = useSubscribeToPriceModalState();

    const {
        modalName: modalNameSubscribeToPrice,
        subscriptionPriceEmail,
        setSubscriptionPriceEmail,
        subscribeToPrice,
        confirmEmail,
        otpSessionData,
        resetEmail,
        verifyEmail
    } = useSubscribeToPriceChange({
        closeSubscribeToPriceModal,
        openSubscribeToPriceModal,
        price: {
            value: price!.value,
            currency: price!.currency
        },
        offerId: model.id,
        setIsFavoriteCurrent: favorites.setIsFavorite
    });

    if (! price) return null;
    if (! model.seller?.mainPhone) return null;

    const moderatorExtension: React.ReactNode = (
        <ModeratorExtension id={model.id} />
    );

    let priceDetail: React.ReactNode | undefined;
    let newBuildingBasicInfo = null;

    let rent: React.ReactNode = null;

    if (dealType?.__typename === 'ProfOfferDealRent') {
        rent = (<>
            {dealType?.hasDeposit?.formatted && <div>{dealType.hasDeposit.formatted}</div>}
            {dealType?.bargainAllowed?.formatted && <div>{dealType.bargainAllowed.formatted}</div>}
            {dealType?.hasPrepayment?.formatted && <div>{dealType.hasPrepayment.formatted}</div>}
            {dealType?.utilities?.formatted && <div>{dealType.utilities.formatted}</div>}
            {dealType?.commission?.formatted && <div>{dealType.commission.formatted}</div>}
        </>);
    }

    switch (realtyObject?.__typename) {
        case 'ProfOfferFlat': {
            priceDetail = (
                <div className={cn('price-detail')}>
                    <PriceDetail
                        totalAreaValue={realtyObject.totalArea?.value ?? 0}
                        totalAreaUnit={areaUnitCompat(realtyObject.totalArea?.unit)}
                        priceValue={price.rubPrice ?? price.value}
                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                        color='black-400'
                        short
                    />
                    {price.rubPrice && (
                        <>
                            <span className={cn('price-detail-separator')}>•</span>
                            <PriceDetail
                                totalAreaValue={realtyObject.totalArea?.value ?? 0}
                                totalAreaUnit={areaUnitCompat(realtyObject.totalArea?.unit)}
                                priceValue={price.value}
                                priceCurrency={price.currency}
                                short
                            />
                        </>
                    )}
                </div>
            );

            const newBuildingInfo = realtyObject?.building?.newBuildingBasicInfo;

            if (newBuildingInfo) {
                newBuildingBasicInfo = (
                    <Typography variant='primary'>
                        <div className={cn('new-building-link')}>
                            <Link
                                href={newBuildingInfo.slug}
                                onClick={() => gtmlClickNewBuildingLink && dataLayerPush({ event: gtmlClickNewBuildingLink })}
                                rel={[ 'noopener' ]}
                            >
                                {newBuildingInfo.title}
                            </Link>
                        </div>
                    </Typography>
                );
            }

            break;
        }

        case 'ProfOfferRoom': {
            priceDetail = (
                <div className={cn('price-detail')}>
                    <PriceDetail
                        totalAreaValue={realtyObject.livingArea?.value ?? 0}
                        totalAreaUnit={areaUnitCompat(realtyObject.livingArea?.unit)}
                        priceValue={price.rubPrice ?? price.value}
                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                        short
                    />
                    {price.rubPrice && (
                        <>
                            <span className={cn('price-detail-separator')}>•</span>
                            <PriceDetail
                                totalAreaValue={realtyObject.livingArea?.value ?? 0}
                                totalAreaUnit={areaUnitCompat(realtyObject.livingArea?.unit)}
                                priceValue={price.value}
                                priceCurrency={price.currency}
                                short
                            />
                        </>
                    )}
                </div>
            );

            break;
        }

        case 'ProfOfferLand': {
            const area = areaCompat(realtyObject.area);

            priceDetail = (
                <div className={cn('price-detail')}>
                    <PriceDetail
                        totalAreaValue={area.value}
                        totalAreaUnit={area.unit}
                        priceValue={price.rubPrice ?? price.value}
                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                        short
                    />
                    {price.rubPrice && (
                        <>
                            <span className={cn('price-detail-separator')}>•</span>
                            <PriceDetail
                                totalAreaValue={area.value}
                                totalAreaUnit={area.unit}
                                priceValue={price.value}
                                priceCurrency={price.currency}
                                short
                            />
                        </>
                    )}
                </div>
            );

            break;
        }

        case 'ProfOfferHouse': {
            const area = areaCompat(realtyObject.totalArea);

            priceDetail = (
                <div className={cn('price-detail')}>
                    <PriceDetail
                        totalAreaValue={area.value}
                        totalAreaUnit={area.unit}
                        priceValue={price.rubPrice ?? price.value}
                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                        short
                    />
                    {price.rubPrice && (
                        <>
                            <span className={cn('price-detail-separator')}>•</span>
                            <PriceDetail
                                totalAreaValue={area.value}
                                totalAreaUnit={area.unit}
                                priceValue={price.value}
                                priceCurrency={price.currency}
                                short
                            />
                        </>
                    )}
                </div>
            );

            break;
        }

        default: {
            return null;
        }
    }

    const hiddenOffer = useMemo(() => {
        return (
            <section className={cn('hiddenOfferSnippet')}>
                <div className={cn('hiddenUserInfo')}>
                    <Typography variant='primary-alone'>
                        Объявление скрыто
                    </Typography>
                    <Typography variant='small-alone'>
                        Все скрытые объявления вы найдёте в&nbsp;<a
                            href={`/hidden-offers#${isSaleOffer ? 'sell' : 'rent'}`}
                            target='_blank'
                            className={cn('lk_link')}>личном кабинете
                        </a>
                    </Typography>
                </div>
                <div className={cn('hiddenOfferInfo')}>
                    <Typography variant='promo-subheader-alone' bold>
                        {model.text?.titleSnippet}
                    </Typography>
                    <Price
                        priceValue={price.rubPrice ?? price.value}
                        // @ts-ignore
                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                        rentPeriod={dealTypePeriodCompat(dealType)}
                    />
                    {price.rubPrice && (
                        <div className={cn('original-price')}>
                            <Price
                                priceValue={price.value}
                                // @ts-ignore
                                priceCurrency={price.currency}
                                rentPeriod={dealTypePeriodCompat(dealType)}
                                hasItemProp
                            />
                        </div>
                    )}
                </div>
                <div className={cn('hiddenIcon')}>
                    <HideButton
                        circle
                        block
                        paddingSize='m'
                        variant='transparent-alt-bg'
                        isActive={hidden.isHidden}
                        onClick={hidden.hiddenToggle}
                    />
                </div>
            </section>
        );
    }, [ hidden ]);

    if (model.isHidden && auth.isAuthenticated) return null;

    const renderOnlinePurchaseOrMortgage = () => {
        if (isSaleOffer && ! isNewBuilding) {
            return (
                <div>
                    <Typography
                        color='blue-500'
                        onClick={() => window.open('/services/deal/', '_blank')}
                        bold
                        variant='primary-alone'
                        className={cn('hover')}
                    >
                        Купить онлайн
                    </Typography>
                    <Typography variant='secondary-alone'>Безопасно, быстро и удобно</Typography>
                </div>
            );
        }

        return null;
    };

    return (hidden.isHidden && auth.isAuthenticated) ? hiddenOffer : (
        <LayoutSnippet
            dataTest='offer'
            id={`offer-${model.id}`}
            onMouseEnter={hoverSnippet}
            onMouseLeave={blurSnippet}
            borderEnabled={borderEnabled}
            hasHighlightPriority={model.status?.hasHighlight}
            hasTopPriority={model.status?.hasTop}
            ref={offerRef}
            renderBadges={
                isPledge || isNewBuilding || isNewBuildingDeveloperFlat || isVisited || onlineView ? (
                    <BadgeBox position='top-left'>
                        {isVisited && (
                            <Badge backgroundColor='#6E6A81'>
                                Просмотрено
                            </Badge>
                        )}
                        {onlineView && (
                            <Badge backgroundColor='#6B4FE8'>
                                {badgeLabel.onlineView}
                            </Badge>
                        )}
                        {isNewBuilding && (
                            <DefaultBadge variant='transparent'>
                                {badgeLabel.newBuilding}
                            </DefaultBadge>
                        )}
                        {isNewBuildingDeveloperFlat && (
                            <DefaultBadge variant='transparent'>
                                {badgeLabel.fromDeveloper}
                            </DefaultBadge>
                        )}
                        {isPledge && (
                            <Badge backgroundColor='#B75DDB'>
                                {badgeLabel.inPledge}
                            </Badge>
                        )}
                    </BadgeBox>
                ) : null
            }
            renderGallery={<>
                <LinkSnippet
                    fullWidth
                    to={offerUrl ?? ''}
                    handleClick={handleOfferSnippetClick}
                >
                    <GallerySnippet
                        isVisited={isVisited}
                        isActive={isHover}
                        withLazyLoad={index !== 0}
                        pictures={pictures}
                        maxPicturesCount={hasAnyPriority ? 8 : 4}
                        isClSnippet
                    />
                </LinkSnippet>
                {isPit && (
                    <HoverTooltip
                        text='Покупка имущества на&nbsp;торгах доступна как для физических, так и&nbsp;для юридических лиц, и&nbsp;дает возможность приобрести недвижимость по&nbsp;стоимости ниже рыночной'
                        visible
                        direction='up'
                    >
                        <span className={cn('pit-description')}>Имущественные торги</span>
                    </HoverTooltip>
                )}
            </>}
            renderTitle={
                <LinkSnippet
                    to={offerUrl ?? ''}
                    isActive={isHover}
                    isVisited={isVisited}
                    handleClick={handleOfferSnippetClick}
                >
                    <Typography variant='promo-subheader-alone' bold>
                        {model.text?.titleSnippet}
                    </Typography>
                    {phone.phoneFormatted && phone.phoneHref && isPhoneModalOpened ? (
                        <OfferPhoneModal2
                            onClose={closePhoneModal}
                            phoneFormatted={phone.phoneFormatted}
                            phoneHref={phone.phoneHref}
                            isNewBuilding={isNewBuilding}
                            isDoppelganger={phone.isDoppelganger}
                            snippet={model}
                            placeCall={placeCallPhoneModal}
                            isSellFlat={isSellFlat}
                        />
                    ) : undefined}
                </LinkSnippet>
            }
            renderBuilding={newBuildingBasicInfo}
            renderMetro={<OfferRouteSnippet
                offerRoutes={offerRoutes}
                url={getStationUrl}
                isClSnippet
            />}
            renderAddress={(
                <ClClickableAddress
                    addresses={addresses}
                    metersToCenterText={metersToCenterText}
                    metersToCenterClick={handleOfferSnippetClick}
                    formattedAddressLong={model.location.formattedAddressLong ?? ''}
                />
            )}
            renderDescription={
                <Typography variant='secondary-alone' color='black-400' tag='p'>
                    {description}
                </Typography>
            }
            renderPrice={
                <>
                    <Price
                        history={price.history ?? undefined}
                        priceValue={price.rubPrice ?? price.value}
                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                        rentPeriod={dealTypePeriodCompat(dealType)}
                        hasHighlight={model.status?.hasHighlight}
                        renderSubscribeToPrice={
                            <SubscribeToPriceChange
                                offerId={model.id}
                                onClose={closeSubscribeToPriceModal}
                                subscriptionPriceEmail={subscriptionPriceEmail}
                                setSubscriptionPriceEmail={setSubscriptionPriceEmail}
                                handleSubmit={subscribeToPrice}
                                confirmEmail={confirmEmail}
                                hasSubscription={model.hasSubscription}
                                nearPriceHistoryPlot={(price.history?.length ?? 0) > 3}
                                formType='desktop-snippet'
                            />
                        }
                    />
                    {price.rubPrice && (
                        <div className={cn('original-price')}>
                            <Price
                                priceValue={price.value}
                                priceCurrency={price.currency}
                                rentPeriod={dealTypePeriodCompat(dealType)}
                                hasItemProp
                            />
                        </div>
                    )}
                    {isOpenSubscribeToPriceModal && (
                        <SubscribeToPriceModal
                            modalName={modalNameSubscribeToPrice}
                            handleClose={closeSubscribeToPriceModal}
                            email={subscriptionPriceEmail}
                            otpSession={otpSessionData}
                            onResetEmail={resetEmail}
                            verifyEmail={verifyEmail}
                        />
                    )}
                </>
            }
            // renderValidate={! isNewBuilding && isSellFlat ? (<div>
            //     <Typography
            //         color='blue-500'
            //         onClick={() => {
            //             handlePhoneLoad(undefined, 'check_request_link');
            //         }}
            //         bold
            //         variant='primary-alone'
            //         className={cn('hover')}
            //         data-test='snippet-legal-check-link'
            //     >
            //         Бесплатно проверить объект
            //     </Typography>
            //     <Typography variant='secondary-alone' data-test='snippet-legal-check-description'>
            //         Выбирайте среди надёжных вариантов без рисков
            //     </Typography>
            // </div>) : null}
            renderOnlinePurchase={renderOnlinePurchaseOrMortgage()}
            renderNewPriceDetail={isSaleOffer ? <>{priceDetail}</> : null}
            renderMortgageLink={null}
            renderNote={favorites.noteText ? (<div className={cn('note')} onClick={favorites.noteEditOpen}>
                <Typography variant='secondary-alone' className={cn('notes')}>{favorites.noteText}</Typography>
            </div>) : null}
            renderModeratorExtension={moderatorExtension}
            renderPaymentsInfo={rent}
            renderPhone={<>
                {isPhone ? (<Phone
                    dataTest='phone-button'
                    phoneFormatted={phone.phoneFormatted}
                    phoneHref={phone.phoneHref}
                    error={Boolean(phone.error)}
                    loading={phone.loading}
                    onClick={handlePhoneLoad}
                    variant={isHover ? 'primary' : 'secondary'}
                />) : (
                    <Button
                        size={'s'}
                        dataTest='phone-button'
                        fullWidth
                        onClick={handlePhoneLoad}
                        variant={isHover ? 'primary' : 'secondary'}
                    >
                        Показать телефон
                    </Button>
                )}
            </>}
            renderSeller={<div className={cn('seller')}>
                <SellerSnippet
                    seller={seller}
                    sellerLogoUrl={model.seller.isZhekaLogo ? model.seller.logo?.origin : ''}
                />
            </div>}
            renderLastUpdate={
                <Typography color='black-400' variant='secondary-alone' className={cn('time')}>
                    {isCreatedAtVisible ?
                        model.status?.createdAt?.formattedAutoDate :
                        model.status?.actualizedAt?.formattedAutoDate
                    }
                </Typography>
            }
            renderNewOnMap={
                <Tooltip
                    mainOffset={8}
                    directions={[ 'bottom-left' ]}
                    renderContent={({ handleClose }) => (
                        <div style={{ width: '700px', height: '300px' }}>
                            <VTBCoreYMapDesktop
                                onClose={handleClose}
                                zoom={16}
                                center={coordinates ? [ coordinates.latitude, coordinates.longitude ] : undefined}
                            />
                        </div>
                    )}
                    renderTrigger={({
                        handleToggle,
                        triggerRef
                    }) => (
                        <div ref={triggerRef} className={cn('newBtn')}>
                            <Link
                                dataTest='offer-map-show'
                                onClick={() => {
                                    handleToggle();
                                    dataLayerPush({ event: 'classified_serp_click_to_map' });
                                }}
                            >
                                На карте
                            </Link>
                        </div>
                    )}
                />
            }
            renderFavoritesButton={model.isFavoriteVisible && model.isFavorite !== null && (
                <>
                    {! isMyOffer && <>
                        {! favorites.isProfessional ? (
                            <FavoritesButton
                                isActive={favorites.isFavorite}
                                onClick={favorites.favoriteToggle}
                                circle
                                block
                                paddingSize='m'
                                variant='transparent-alt-bg'
                            />
                        ) : (
                            <AgentFavoritesDropdown
                                isMyFavorite={favorites.isFavorite}
                                offerId={model.id}
                                onChangeMyFavorite={(v) => favorites.updateFavorite({
                                    isFavorite: v
                                })}
                                renderTrigger={({ handleToggle }) => (
                                    <FavoritesButton
                                        isActive={favorites.isFavorite}
                                        onClick={handleToggle}
                                        circle
                                        block
                                        paddingSize='m'
                                        variant='transparent-alt-bg'
                                    />
                                )}
                            />
                        )}
                    </>}
                    <NotesButton
                        circle
                        block
                        paddingSize='m'
                        variant='transparent-alt-bg'
                        isActive={Boolean(favorites.noteText)}
                        onClick={favorites.noteEditOpen}
                    />
                    {(auth.isAuthenticated && ! isMyOffer) ? <HideButton
                        circle
                        block
                        paddingSize='m'
                        variant='transparent-alt-bg'
                        isActive={hidden.isHidden}
                        onClick={hidden.hiddenToggle}
                    /> : null}
                    <ReportButton offerId={model.id} isClSnippet />
                    {favorites.isNoteEditing && (<NotesEditor
                        noteTextInitial={favorites.noteText}
                        noteSubmit={favorites.noteSave}
                        noteDelete={favorites.noteDelete}
                        onClose={favorites.noteEditClose}
                    />)}
                </>
            )}
            renderOwnerInfo={null}
        />
    );
}));
